/*
<div class="page" style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none;"
    title="Page 1"><span style="color: rgb(69, 69, 69); font-size: 20px;">Hallo ${bandname},&nbsp;</span><br><br><span
        style="font-size: 20px;"><span style="color: rgb(69, 69, 69);">mit dieser Mail erhaltet ihr eure Einladung zur
            Bandbewerbung für das 41. Kalkwerkfestival.<span class="Apple-converted-space">&nbsp;</span><br>Das
            Festival findet dieses Jahr vom 09.-11. Juni statt.&nbsp;</span></span><br><br><span
        style="font-size: 20px;"><span style="font-weight: 700; color: rgb(69, 69, 69);">Der Bewerbungszeitraum endet am
            Samstag, 25. Februar.&nbsp;</span></span><br><br><span style="font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">Bitte vervollständigt bis dahin eure Banddaten, Infos und Foto für unsere
            Website, Facebook und das Festivalprogrammheft.<span class="Apple-converted-space">&nbsp;</span><br>Ihr habt
            die Möglichkeit, euch mit den Zugangsdaten einzuloggen und die Daten einzugeben. <span
                class="Apple-converted-space">&nbsp;</span></span></span><br><br><span style="font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">Ihr müsst nicht alle Angaben auf einmal eingeben, sondern könnt euch bis
            zum Ablauf der Bewerbungsfrist jederzeit erneut einloggen, um eure Bewerbung zu
            vervollständigen.</span></span><br><br>
            <div class="layoutArea"><span style="font-size: 20px;"><span style="color: #454545;">Wir freuen uns über Eure Bewerbung</span></span></div>
            <p><span style="font-size: 20px;"><span style="color: #454545;">Mark Pfurtscheller</span></span><br /><span style="font-size: 20px;"><span style="color: #454545;">Musikprogramm</span></span></p>
            <p><span style="font-size: 20px;"><span style="color: #454545;">Eric Sidibe<br />IT - Bewerbungsportal </span></span><span style="font-size: 20px;"><span style="color: #454545;"><span class="Apple-converted-space">&nbsp;</span></span></span><br /><br /><span style="font-size: 20px;"><span style="color: #454545;">***************************************</span></span><br /><br /><span style="font-size: 20px;"><span style="font-weight: bold; color: #454545;">Dies sind eure Zugangsdaten:&nbsp;</span></span></p>
<div class="page"
    style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none;"
    title="Page 1"><br><span style="font-size: 20px;"><a href="https://bewerbung.kalkwerk.org/"><span
                style="color: rgb(69, 69, 69);"><em>http://bewerbung.kalkwerk.org&nbsp;</em></span></a><span
            class="Apple-converted-space">&nbsp;</span></span><br><span style="font-size: 20px;"><em><span
                style="color: rgb(69, 69, 69);"><strong>Loginname: &nbsp;${loginname}</strong></span></em></span><span
        class="Apple-converted-space">&nbsp;</span><br><span style="font-size: 20px;"><span
            style="color: rgb(69, 69, 69);"><strong><em>Passwort: ${savedPassword}</em></strong></span></span><br><br>
</div>
<p><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">***************************************</span></span><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-size: 12px; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; display: inline !important; float: none;"><span
            class="Apple-converted-space">&nbsp;</span></span></p>
<p><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">Bei Fragen zur Bandbewerbung<span
                class="Apple-converted-space">&nbsp;</span></span></span></p>
<p><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">E-Mail:<span class="Apple-converted-space">&nbsp;</span><a
                class="moz-txt-link-abbreviated moz-txt-link-freetext"
                href="mailto:musikprogramm@kalkwerkfestival.org">musikprogramm@kalkwerkfestival.org</a><span
                class="Apple-converted-space">&nbsp;</span></span></span></p>
<p><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">Tel: 01520 1966026<span
                class="Apple-converted-space">&nbsp;</span></span></span></p>
<p><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">Bei technischen Fragen zum Bewerbungsportal:<span
                class="Apple-converted-space">&nbsp;</span></span></span></p>
<p><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">E-Mail:<span class="Apple-converted-space">&nbsp;</span><a
                class="moz-txt-link-abbreviated moz-txt-link-freetext"
                href="mailto:eric@sidibe.de">eric@sidibe.de</a><span
                class="Apple-converted-space">&nbsp;</span></span></span></p>
<p><span
        style="caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255); font-family: Helvetica; font-style: normal; font-variant-caps: normal; font-weight: normal; letter-spacing: normal; orphans: auto; text-align: start; text-indent: 0px; text-transform: none; white-space: normal; widows: auto; word-spacing: 0px; -webkit-text-size-adjust: auto; -webkit-text-stroke-width: 0px; text-decoration: none; font-size: 20px;"><span
            style="color: rgb(69, 69, 69);">Tel: 0176 10366691 &nbsp; &nbsp;</span></span></p>
*/
/*`Hallo ${bandname},<br/>
<br/>
Nun nochmals das Musikprogramm für das Kalkwerkfestival 2018<br/>
<br/>
Es haben sich noch ein paar Änderungen gegenüber dem vorläufigen Programm ergegeben.<br/>
Bitte schaut nochmals konkret auf eure Spielzeiten und meldet euch so schnell wie
möglich, falls etwas nicht passen sollte.
<br/>
An die Nachrücker: Bitte haltet euch trotzdem bereit. Es kommt jedes Jahr vor, dass Bands ausfallen. Mal drei Wochen vorher - mal ganz kurzfristig direkt am Festival.<br/>
<br/>
Ich freue mich mit allen Bands auf ein tolles Musikprogramm.<br/>
<br/>
Mark Pfurtscheller
<br/>
<br/>
 
<table width="583" border="1" bordercolor="#c1c1c1" cellpadding="7" cellspacing="0">
<colgroup><col width="184">
<col width="178">
<col width="177">
</colgroup><tbody><tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><br>
</p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>38.
Kalkwerkfestival 08.-10.06.2018</b></font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Zeit</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>Freitag</b></font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">19:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Einlass</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">20:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Varieté</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">23:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Strictly
Mint</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178" bgcolor="#ffffff">
<p><br>
</p>
</td>
<td width="177" bgcolor="#ffffff">
<p><br>
</p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p><br>
</p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>Samstag</b></font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">13:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Sevenleaves</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">14:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Kaocide</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">15:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Indicate</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">16:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">GirlPolice</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">17:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Bloodspot</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">18:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Battle
X</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">19:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Polyone</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">20:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Bouncing
Bettys</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">21:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4"
      style="font-size: 16pt">The Bright Circle</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">22:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Umbau</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>22:30</b></font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>Benjie and Ridm&Chop Band </b></font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">0:00</font></font></font></p>
</td>
<td width="177">
<p><br>
</p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p><br>
</p>
</td>
<td width="177">
<p><br>
</p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p><br>
</p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>Sonntag</b></font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">13:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">4
Zimmmer Küche Bad</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">14:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Lillian</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">15:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Radio
Sancho</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">16:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Ella!Phonk</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">17:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4"
      style="font-size: 16pt">Far Beneath</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">18:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Eves Temptation</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">19:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Driven</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">20:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Sidibeat</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">21:00</font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Umbau</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>21:30</b></font></font></font></p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt"><b>Alpargata</b></font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p align="RIGHT"><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">23:00</font></font></font></p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Paris</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p><br>
</p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Nachrücker:</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p><br>
</p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Cruel
Division</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p><br>
</p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Chaosfront</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184" bgcolor="#ffff0b">
<p><br>
</p>
</td>
<td width="178">
<p><br>
</p>
</td>
<td width="177">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Strobocop</font></font></font></p>
</td>
</tr>
<tr valign="BOTTOM">
<td width="184">
<p><br>
</p>
</td>
<td width="178" bgcolor="#ffffff">
<p><br>
</p>
</td>
<td width="177" bgcolor="#ffffff">
<p><font color="#000000"><font face="ArialMT, sans-serif"><font size="4" style="font-size: 16pt">Boiler</font></font></font></p>
</td>
</tr>
</tbody></table>`
*/

/*`Hallo ${bandname},

KALK38CD

Wie bereits in den vergangenen Jahren produzieren wir eine CD Compilation mit allen Festivalbands !

Dafür benötigen wir von euch bis spätestens 1. April:

> zwei Titel zur Auswahl mit korrekten Urheberangaben (Komponist/Texter) und Titellängen
> (Komponist/Texter als Echtnamen ! Beispiel: K= Hans Glück T= Grete Gans)
> max Titellänge 3:40 min
> Format: WAV oder AIF 44,1 KHz/24bit
> auf Daten CD oder USB Stick oder download link

Die Aufnahmen schickt ihr mir am besten per "wetransfer" oder "dropbox" link.
Oder bei mir in den Briefkasten werfen oder beim Samstagsgespräch am 19.03. abgeben.

!!! WICHTIG !!!

Der Bewerbungsfrist zum Kalkwerkfestival endet am 03. März

Mark Pfurtscheller
Musikprogramm und Webteam`
*/
/*`mit dieser Mail erhaltet ihr eure Einladung zur Bandbewerbung für das 38. Kalkwerkfestival 2018.
Das Festival findet dieses Jahr vom 08.-10. Juni statt.

Der vierwöchige Bewerbungszeitraum endet am Samstag, 03. März .

Bitte vervollständigt bis dahin eure Banddaten + Foto für unsere Website und das Festivalprogrammheft.
Ihr habt die Möglichkeit euch mit den Zugangsdaten einzuloggen und die Banddaten einzugeben.
Ihr müsst nicht alle Angaben auf einmal eingeben, sondern könnt euch bis zum Ablauf der Bewerbungsfrist jederzeit erneut einloggen, um eure Bewerbung zu vervollständigen.

Dies sind eure Zugangsdaten:
Link zur Bewerbungsseite: http://bewerbung.kalkwerk.org
Loginname: ${loginname}
Passwort: ${savedPassword}

Alle Bands, die noch nicht auf dem Kalkwerkfestival aufgetreten sind oder ein ein neues Songrepertoire haben und noch keine Hörprobe/Demo abgegeben oder, bitten wir darum eine aktuelle Hörprobe abzugeben (CD, USB-Stick,download link). Die Klangqualität ist dabei zweitrangig. Es reicht auch eine Mikrofonaufnahme aus dem Proberaum. 

Bitte beschriftet die CD/USBStick mit eurem Bandnamen und werft sie mir in den Briefkasten oder gebt sie beim Samstagsgespräch ab.

Wir freuen uns über Eure Bewerbung und auf ein tolles Kalkwerkfestival !!!

Mark Pfurtscheller

für Musikprogramm und Webteam
Bei Fragen zum Musikprogramm und CD Produktion wendet euch bitte an mich.

Musikprogramm@kalkwerkfestival.org
01520 1966026

Bei technischen Fragen und Anregungen zum Bewerbungsportal wendet euch bitte an Eric Sidibe.
ericsidibe@online.de
0176 10366691`
*/



/*
<html>
<head><meta http-equiv=Content-Type content="text/html; charset=UTF-8">
<style type="text/css">
<!--
span.cls_002{font-family:Arial,serif;font-size:11.8px;color:rgb(69,68,69);font-weight:bold;font-style:normal;text-decoration: none}
div.cls_002{font-family:Arial,serif;font-size:11.8px;color:rgb(69,68,69);font-weight:bold;font-style:normal;text-decoration: none}
span.cls_003{font-family:Arial,serif;font-size:11.8px;color:rgb(69,68,69);font-weight:normal;font-style:normal;text-decoration: none}
div.cls_003{font-family:Arial,serif;font-size:11.8px;color:rgb(69,68,69);font-weight:normal;font-style:normal;text-decoration: none}
-->
</style>
<script type="text/javascript" src="b329ac98-26e5-11e9-8f58-0cc47a792c0a_id_b329ac98-26e5-11e9-8f58-0cc47a792c0a_files/wz_jsgraphics.js"></script>
</head>
<body>
<div style="position:absolute;left:50%;margin-left:-297px;top:0px;width:595px;height:842px;border-style:outset;overflow:hidden">
<div style="position:absolute;left:76.54px;top:116.71px" class="cls_002"><span class="cls_002">Aufruf Bandbewerbung KW 5 So. 03. Februar über das</span></div>
<div style="position:absolute;left:76.54px;top:132.39px" class="cls_002"><span class="cls_002">Bandbewerbungsportal</span></div>
<div style="position:absolute;left:76.54px;top:163.75px" class="cls_003"><span class="cls_003">Hallo ${bandname},</span></div>
<div style="position:absolute;left:76.54px;top:195.10px" class="cls_003"><span class="cls_003">mit dieser Mail erhaltet ihr eure Einladung zur Bandbewerbung für das 39.</span></div>
<div style="position:absolute;left:76.54px;top:210.78px" class="cls_003"><span class="cls_003">Kalkwerkfestival 2019.</span></div>
<div style="position:absolute;left:76.54px;top:226.46px" class="cls_003"><span class="cls_003">Das Festival findet dieses Jahr vom 07.-09. Juni statt.</span></div>
<div style="position:absolute;left:76.54px;top:257.81px" class="cls_002"><span class="cls_002">Der vierwöchige Bewerbungszeitraum endet am Samstag, 03. März.</span></div>
<div style="position:absolute;left:76.54px;top:289.17px" class="cls_003"><span class="cls_003">Bitte vervollständigt bis dahin eure Banddaten, Info und Foto für unsere</span></div>
<div style="position:absolute;left:76.54px;top:304.85px" class="cls_003"><span class="cls_003">Website, Facebook und das Festivalprogrammheft.</span></div>
<div style="position:absolute;left:76.54px;top:320.53px" class="cls_003"><span class="cls_003">Ihr habt die Möglichkeit euch mit den Zugangsdaten einzuloggen und die</span></div>
<div style="position:absolute;left:76.54px;top:336.21px" class="cls_003"><span class="cls_003">Banddaten einzugeben.</span></div>
<div style="position:absolute;left:76.54px;top:351.88px" class="cls_003"><span class="cls_003">Ihr müsst nicht alle Angaben auf einmal eingeben, sondern könnt euch bis zum</span></div>
<div style="position:absolute;left:76.54px;top:367.56px" class="cls_003"><span class="cls_003">Ablauf der Bewerbungsfrist jederzeit erneut einloggen, um eure Bewerbung zu</span></div>
<div style="position:absolute;left:76.54px;top:383.24px" class="cls_003"><span class="cls_003">vervollständigen.</span></div>
<div style="position:absolute;left:76.54px;top:414.60px" class="cls_002"><span class="cls_002">Dies sind eure Zugangsdaten:</span></div>
<div style="position:absolute;left:76.54px;top:430.27px" class="cls_003"><span class="cls_003">Link zur Bewerbungsseite: </span><A HREF="http://bewerbung.kalkwerk.org/">http://bewerbung.kalkwerk.org</A> </div>
<div style="position:absolute;left:76.54px;top:461.63px" class="cls_003"><span class="cls_003">Loginname:  ${loginname} </span></div>
<div style="position:absolute;left:76.54px;top:477.31px" class="cls_003"><span class="cls_003">Passwort: ${savedPassword} </span></div>

<div style="position:absolute;left:76.54px;top:492.99px" class="cls_002"><span class="cls_002"></span></div>
<div style="position:absolute;left:76.54px;top:492.99px" class="cls_002"><span class="cls_002"><br/>KALK39CD</span></div>
<div style="position:absolute;left:76.54px;top:524.34px" class="cls_003"><span class="cls_003">Wie bereits in den vergangenen Jahren produzieren wir eine CD Compilation</span></div>
<div style="position:absolute;left:76.54px;top:540.02px" class="cls_003"><span class="cls_003">mit allen Festivalbands !</span></div>
<div style="position:absolute;left:76.54px;top:571.38px" class="cls_003"><span class="cls_003">Dafür benötigen wir von euch bis spätestens 03. März:</span></div>
<div style="position:absolute;left:76.54px;top:587.05px" class="cls_002"><span class="cls_002">> zwei Titel zur Auswahl mit korrekten Urheberangaben (Komponist/</span></div>
<div style="position:absolute;left:76.54px;top:602.73px" class="cls_002"><span class="cls_002">Texter) und Titellängen</span></div>
<div style="position:absolute;left:76.54px;top:618.41px" class="cls_002"><span class="cls_002">> (Komponist/Texter als Echtnamen ! Beispiel: K= Hans Glück T= Grete</span></div>
<div style="position:absolute;left:76.54px;top:634.09px" class="cls_002"><span class="cls_002">Gans)</span></div>
<div style="position:absolute;left:76.54px;top:649.77px" class="cls_002"><span class="cls_002">> max Titellänge 3:40 min</span></div>
<div style="position:absolute;left:76.54px;top:665.44px" class="cls_002"><span class="cls_002">> Format: WAV oder AIF 44,1 KHz/24bit</span></div>
<div style="position:absolute;left:76.54px;top:681.12px" class="cls_002"><span class="cls_002">> auf Daten CD oder USB Stick oder download link</span></div>
<div style="position:absolute;left:76.54px;top:712.48px" class="cls_003"><span class="cls_003">Die Aufnahmen könnt ihr mir per "wetransfer", "dropbox" Link, Briefkasten im Kalkwerk oder an den Samstagsgesprächen zukommen lassen</span></div>

<div style="position:absolute;left:76.54px;top:759.51px" class="cls_003"><span class="cls_003"><br/>Alle Bands, die noch nicht auf dem Kalkwerkfestival aufgetreten sind oder Bands</span></div>
</div>
<div style="position:absolute;left:50%;margin-left:-297px;top:852px;width:595px;height:842px;border-style:outset;overflow:hidden">
<div style="position:absolute;left:0px;top:0px">
</div>
<div style="position:absolute;left:76.54px;top:54.00px" class="cls_003"><span class="cls_003">welche ein neues Songrepertoire haben bitten wir darum eine aktuelle Hörprobe abzugeben</span></div>
<div style="position:absolute;left:76.54px;top:69.68px" class="cls_003"><span class="cls_003">(CD, USB, Stick, Downloadlink). </span></div>
<div style="position:absolute;left:76.54px;top:85.36px" class="cls_003"><span class="cls_003">Die Klangqualität ist dabei zweitrangig. Es reicht auch eine Mikrofonaufnahme aus dem Proberaum.</span></div>
<div style="position:absolute;left:76.54px;top:101.03px" class="cls_003"><span class="cls_003"></span></div>
<div style="position:absolute;left:76.54px;top:132.39px" class="cls_003"><span class="cls_003">Bitte beschriftet die CD/USBStick mit eurem Bandnamen und werft sie mir in</span></div>
<div style="position:absolute;left:76.54px;top:148.07px" class="cls_003"><span class="cls_003">den Briefkasten oder gebt sie mir beim Samstagsgespräch.</span></div>
<div style="position:absolute;left:76.54px;top:163.75px" class="cls_003"><span class="cls_003">Wir freuen uns über Eure Bewerbung und auf ein tolles Kalkwerkfestival ;) </span></div>
<div style="position:absolute;left:76.54px;top:195.10px" class="cls_003"><span class="cls_003">Mark Pfurtscheller</span></div>
<div style="position:absolute;left:76.54px;top:210.78px" class="cls_003"><span class="cls_003">für Musikprogramm und Webteam</span></div>
<div style="position:absolute;left:76.54px;top:242.14px" class="cls_003"><span class="cls_003">Bei technischen Fragen und Anregungen zum Bewerbungsportal wendet euch</span></div>
<div style="position:absolute;left:76.54px;top:257.82px" class="cls_003"><span class="cls_003">bitte an Eric Sidibe.</span></div>
<div style="position:absolute;left:76.54px;top:273.49px" class="cls_003"><span class="cls_003">eric@ongress.com</span></div>
<div style="position:absolute;left:76.54px;top:289.17px" class="cls_003"><span class="cls_003">0176 10366691</span></div>
</div>
</body>
</html>

*/

/* 2023 aufruf cd
<div title="Page 1">
    <div title="Page 1">
        <div>
            <div>
                <div>
                    <p>Liebe Kalkwerkmusiker:innen,</p>die Bandbewerbung für das 41. Kalkwerkfestival ist im vollem Gange. Ich hoffe ihr kommt alle gut mit dem Bewerbungsportal zurecht.<br>Ich habe es gerade selbst ausprobiert.<br>Übersichtlich - leicht verständlich. &nbsp;<p><strong>Die Bandbewerbung läuft noch vier Tage und endet am 25.02.2022. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</strong></p>
                    <p><strong>Seit nunmehr 11 Jahren produzieren wir zum
                      Festival eine CD Compilation mit allen
                      Festivalbands&nbsp;!<br>So auch diese
                    Jahr.</strong></p>Dafür benötigen wir von euch bis 04. März
                  zwei Titel zur Auswahl<br><br>&gt; max Titellänge 4:15
                  min<br>&gt; Format: WAV oder AIF 44,1 KHz/24bit<br>&nbsp;
                  &nbsp;(16bit geht auch 24bit wäre besser)<br>&gt;
                  Urheberangaben und Titellänge: &nbsp;<br>&nbsp;
                  &nbsp;Komponist (K= xxx) Texter T=xxx)<br>&gt;
                  Komponist/Texter als Echtnamen - keine Bandnamen
                  !<br>&nbsp;&nbsp; Beispiel: K= Hans Glück T= Grete
                  Gans<br>&nbsp;<p><strong>Bitte schickt die Audiofiles per
                  wetransfer oder dropbox link an Dateien mit Bandname und Titel
                beschriften!</strong></p><a
                                             href="mailto:musikprogramm@kalkwerkfestival.org">musikprogramm@kalkwerkfestival.org<br></a>
              &nbsp;<p>Alle Bands, die noch nicht auf dem Kalkwerkfestival
              aufgetreten sind oder ein ein neues Songrepertoire haben, bitte
              ich darum eine aktuelle Hörprobe abzugeben.<br>(CD, USB-
              Stick,download link).</p>Die Klangqualität ist hierbei
              zweitrangig. Dafür reicht auch eine Mikrofonaufnahme aus dem
              Proberaum.<p>Wir freuen uns auf ein tolles Kalkwerkfestival
              2022!!!</p>Mark Pfurtscheller &nbsp;<br>Musikprogramm<p>
                </div>
            </div>
        </div>
    </div>
</div>
*/
function sendBandMail(bandId) {
  var band = Bands.findOne(bandId); 
  var bandname  = band.name
  var contactPersonId= band.contactPerson;
  var contactPerson = Meteor.users.findOne(contactPersonId)
  var contactEmail = contactPerson.emails[0].address;
  var loginname =  contactEmail;
  var savedPassword;

  if ( contactPerson.profile) {
    savedPassword = contactPerson.profile.pwPlain 
  } else {
    savedPassword = contactPerson.pwPlain
  }

  console.log("Bandname: " + bandname)
  console.log("send Mail to: " + contactEmail)

  Email.send({
    to: contactEmail,
    bcc: ["eric@ongress.com"],
    from: "bandbewerbung@kalkwerkfestival.org",
    replyTo: "bewerbung@kalkwerkfestival.org",
    subject: "Bandbewerbung - Kalkwerkfestival 42. vom 07-09.06",
    html:`<!DOCTYPE html>
	<html>
	<head>
	    <title>Bandbewerbung - Kalkwerkfestival</title>
	    <style>
		body {
		    font-family: Arial, sans-serif;
		    color: #333333;
		    margin: 0;
		    padding: 0;
		}
		.container {
		    max-width: 700px;
		    margin: 0 auto;
		    padding: 20px;
		}
		@media screen and (max-width: 600px) {
		    .container {
			width: 100%;
			padding: 10px;
		    }
		}
		.header {
		    font-size: 20px;
		    margin-bottom: 20px;
		}
		.content {
		    font-size: 16px;
		    line-height: 1.6;
		}
		.footer {
		    font-size: 14px;
		    color: #888888;
		    margin-top: 30px;
		    border-top: 1px solid #DDDDDD;
		    padding-top: 15px;
		}
		a {
		    color: #007BFF;
		    text-decoration: none;
		}
	    </style>
	</head>
	<body>
	    <div class="container">
		<div class="header">
		    Hallo ${bandname},
		</div>
		<div class="content">
		    <p>mit dieser Mail erhaltet ihr eure Einladung zur Bandbewerbung für das 42. Kalkwerkfestival.</p>
	    	    <p>Das Festival findet dieses Jahr vom <b>07. bis 09. Juni</b> statt. </br>
		    Der Bewerbungszeitraum endet am <b>16. Februar</b>.</p>

		    <p>Bitte vervollständigt bis dahin eure Banddaten, Infos und Foto für unsere Website, Facebook und das Festivalprogrammheft.</p>

		    <p>Ihr habt die Möglichkeit, euch mit den Zugangsdaten einzuloggen und die Daten einzugeben.</p>

		    <p>Ihr müsst nicht alle Angaben auf einmal eingeben, sondern könnt euch bis zum Ablauf der Bewerbungsfrist jederzeit erneut einloggen, um eure Bewerbung zu vervollständigen.</p>

		    <p>Falls keine Audioaufnahmen auf eurer angegebenen Webseite oder Facebook zu finden sind, schickt bitte zusätzlich eine aktuelle Hörprobe an <a href="mailto:bandbewerbung@kalkwerkfestival.org">bandbewerbung@kalkwerkfestival.org</a> (Wetransfer, Dropbox oder Link).</p>

		    <p>Wir freuen uns über Eure Bewerbung<br><br>
		    Eric Sidibe<br>
		    Musikprogramm</p>

		    <p>***************************************</p>

		    <p>Dies sind eure Zugangsdaten:<br> <br/>
		    <a href="https://bewerbung.kalkwerk.org">https://bewerbung.kalkwerk.org</a><br>
		    <b>Benutzername:</b> ${loginname}<br>
		    <b>Passwort:</b> ${savedPassword}</p>

		    <p>***************************************</p>

		    <p>Du hast Fragen und/oder Anregungen?<br>
		    Schreib gerne eine E-Mail an: <a href="mailto:bandbewerbung@kalkwerkfestival.org">bandbewerbung@kalkwerkfestival.org</a><br>
		    oder via Tel: / Whatsapp / Signal: 017610366691</p>
		</div>
	    </div>
	</body>
	</html>`
  });
}

Meteor.methods({
  sendBandMail: function (bandId) {
    sendBandMail(bandId);
  },
  sendMailToAllBands: function () {
    console.log('Blubb');
    // sendBandMail(bandId);
  }
});
